__turbopack_context__.v({
  "clearButtonWrp": "clearButton-module-scss-module__cATZra__clearButtonWrp",
  "clearableBtn": "clearButton-module-scss-module__cATZra__clearableBtn",
  "small": "clearButton-module-scss-module__cATZra__small",
});
